import { render, staticRenderFns } from "./texting-form.vue?vue&type=template&id=6a6fe3a4&scoped=true"
import script from "./texting-form.vue?vue&type=script&lang=js"
export * from "./texting-form.vue?vue&type=script&lang=js"
import style0 from "./texting-form.vue?vue&type=style&index=0&id=6a6fe3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fe3a4",
  null
  
)

export default component.exports